import React, {Component} from 'react';
import './EconomicCapital.style.scss';
import ic from 'assets/icons/grid-view.svg';
import {get} from 'lodash';
import {nFormatter, ONE_BILLION} from '../../../../utils';
export default class EconomicCapital extends Component {
  render() {
    return (
      <div className='eco-container'>
        <h1 className='title'>
          <img src={ic} alt='' style={{marginRight: 8}} />
          ECONOMIC CAPITAL
        </h1>
        <div>
          <span className='price'>
            {nFormatter(get(this.props.data, 'pr_bankwide[0].n_economic_capital', 0) / ONE_BILLION)}
          </span>
          <span className='unit'>bil. VND</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/EconomicCapital/EconomicCapital.js